import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, Flag, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EASE } from '../lib/motion';

interface BulkActionBarProps {
  count: number;
  onMarkContacted: () => void;
  onSetHighPriority: () => void;
  onClear: () => void;
}

export function BulkActionBar({ count, onMarkContacted, onSetHighPriority, onClear }: BulkActionBarProps) {
  return (
    <AnimatePresence initial={false}>
      {count > 0 && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2, ease: EASE }}
          className="overflow-hidden"
        >
          <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-primary/20 bg-primary/5 px-3 py-2">
            <span className="text-sm font-medium text-primary">
              {count} lead{count > 1 ? 's' : ''} selected
            </span>
            <div className="flex flex-wrap items-center gap-2">
              <Button variant="outline" size="sm" className="h-8" onClick={onMarkContacted}>
                <CheckCircle2 className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
                Mark contacted
              </Button>
              <Button variant="outline" size="sm" className="h-8" onClick={onSetHighPriority}>
                <Flag className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
                Set high priority
              </Button>
              <Button variant="ghost" size="sm" className="h-8 text-muted-foreground" onClick={onClear}>
                <X className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
                Clear
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
